import { AppBar, Container, LinearProgress, Toolbar } from "@mui/material";
import React from "react";
import useEmailHeaderFooter from "../../hooks/useEmailHeaderFooter";

const OnsiteHeader = () => {
  const { data, isLoading } = useEmailHeaderFooter();
  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <AppBar position="static" style={{ backgroundColor: "#054054" }}>
      <Toolbar style={{ justifyContent: "center" }}>
        <Container maxWidth="lg">
          {data && (
            <img
              alt="header"
              src={data?.headerUrl}
              style={{
                display: "block",
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
              }}
            />
          )}
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default OnsiteHeader;
